import cn from 'classnames';
import { useCallback } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useOpenNotification } from 'utils/antd/notification-toasts';

import { CopyIcon } from '../Icon/CopyIcon';

type Props = {
  address: string;
  copyable?: boolean;
  truncate?: boolean;
  className?: string;
};

const TRUNCATE_MIN_LENGTH = 18; // 8 prefix + 3 filler + 7 suffix

const truncateAddress = (address: string) => {
  if (address.length <= TRUNCATE_MIN_LENGTH) {
    return address;
  }
  return `${address.substring(0, 8)}...${address.substring(address.length - 7)}`;
};

export const CryptoAddress = ({
  address,
  copyable = true,
  truncate = true,
  className
}: Props) => {
  const openNotification = useOpenNotification();

  const success = useCallback(
    (text: string) => {
      openNotification({
        kind: 'success',
        message: `${text} has been copied to your clipboard`
      });
    },
    [openNotification]
  );

  const displayValue = truncate ? truncateAddress(address) : address;
  const displayed = <span>{displayValue}</span>;

  if (!copyable) {
    return (
      <span className={cn('inline-flex items-center text-xs', className)}>
        {displayed}
      </span>
    );
  }

  return (
    <CopyToClipboard text={address} onCopy={(text) => success(text)}>
      <span
        className={cn(
          'inline-flex cursor-pointer items-center gap-1 text-xs',
          className
        )}
      >
        {displayed}
        <CopyIcon width={14} height={14} stroke="auto" className="shrink-0" />
      </span>
    </CopyToClipboard>
  );
};
